import { Box, Stack, Typography } from "@mui/material";

interface ComingSoonBannerProps {
  title: string;
  tag1: string;
  tag2: string;
  gradient?: string;
  iconSrc?: string;
  glowColor?: string;
}

const DEFAULT_GRADIENT = "linear-gradient(180deg, #289A47 0.32%, #32A74D 11.7%, #3DB454 36.89%, #45BD58 73.63%, #48C15A 87.62%, #4EC95E 100%)";
const DEFAULT_ICON = "/assets/whatsapp_title_banner.png";
const DEFAULT_GLOW = "#7EF98E";

export default function ComingSoonBanner({ title, tag1, tag2, gradient = DEFAULT_GRADIENT, iconSrc = DEFAULT_ICON, glowColor = DEFAULT_GLOW }: ComingSoonBannerProps) {
  const glowRgb = glowColor.startsWith("#")
    ? hexToRgb(glowColor)
    : glowColor;

  return (
    <Box
      sx={{
        borderRadius: "10px",
        overflow: "hidden",
        height: 85,
        mx: 2,
        mt: 2,
        position: "relative",
        background: gradient,
      }}
    >
      <Box sx={{ position: "absolute", width: 161, height: 161, left: -89, top: -64, zIndex: 0, borderRadius: "50%", background: `radial-gradient(50% 50% at 50% 50%, ${glowColor} 0%, ${glowRgb ? `rgba(${glowRgb}, 0)` : "transparent"} 100%)`, filter: "blur(14px)" }} />
      <Box sx={{ position: "absolute", inset: 0, zIndex: 0, backgroundImage: `url('/assets/recimg.png')`, backgroundSize: "220px 220px", mixBlendMode: "soft-light", opacity: 0.7 }} />
      <Box component="img" src="/assets/lightning-1.svg" alt="" sx={{ position: "absolute", left: -50, top: -37, width: 158, zIndex: 1 }} />
      <Box component="img" src="/assets/lightning-1.svg" alt="" sx={{ position: "absolute", left: 227, top: -24, width: 157, zIndex: 1 }} />
      <Box component="img" src="/assets/navbar/star.png" alt="" sx={{ position: "absolute", left: -6, top: 12, width: 19, zIndex: 2 }} />
      <Box component="img" src="/assets/navbar/star.png" alt="" sx={{ position: "absolute", left: 286, top: -7, width: 14, zIndex: 2 }} />
      <Box component="img" src="/assets/navbar/star.png" alt="" sx={{ position: "absolute", left: 316, top: 72, width: 14, zIndex: 2 }} />

      <Stack direction="row" alignItems="center" gap={1} sx={{ position: "relative", zIndex: 3, height: "100%", px: 2 }}>
        <Box component="img" src={iconSrc} alt="" sx={{ width: 40, height: 40, flexShrink: 0, mixBlendMode: "plus-lighter" }} />
        <Stack gap={0.5}>
          <Typography fontWeight={700} fontSize={16} color="white" letterSpacing="-0.48px">{title}</Typography>
          <Stack direction="row" gap={1}>
            <Box sx={{ bgcolor: "rgba(250,250,250,0.5)", backdropFilter: "blur(0.75px)", borderRadius: "10px", px: "6px", py: "2px" }}>
              <Typography fontSize={10} fontWeight={700} color="white">{tag1}</Typography>
            </Box>
            <Box sx={{ bgcolor: "rgba(250,250,250,0.5)", backdropFilter: "blur(0.75px)", borderRadius: "10px", px: "6px", py: "2px" }}>
              <Typography fontSize={10} fontWeight={700} color="white">{tag2}</Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}

function hexToRgb(hex: string): string | null {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
  return `${r}, ${g}, ${b}`;
}
